import { render, staticRenderFns } from "./ClinicFinanceReceivables.vue?vue&type=template&id=347e7806"
import script from "./ClinicFinanceReceivables.vue?vue&type=script&lang=js"
export * from "./ClinicFinanceReceivables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports